export const GET_USER_TRACKING_REQUEST = "GET_USER_TRACKING_REQUEST";
export const GET_USER_TRACKING_SUCCESS = "GET_USER_TRACKING_SUCCESS";
export const GET_USER_TRACKING_FAIL = "GET_USER_TRACKING_FAIL";

export const GET_INSPECTORS_REQUEST = "GET_INSPECTORS_REQUEST";
export const GET_INSPECTORS_SUCCESS = "GET_INSPECTORS_SUCCESS";
export const GET_INSPECTORS_FAIL = "GET_INSPECTORS_FAIL";

export const GET_USER_TRACKING_SUMMARY_REQUEST = "GET_USER_TRACKING_SUMMARY_REQUEST";
export const GET_USER_TRACKING_SUMMARY_SUCCESS = "GET_USER_TRACKING_SUMMARY_SUCCESS";
export const GET_USER_TRACKING_SUMMARY_FAIL = "GET_USER_TRACKING_SUMMARY_FAIL";
